export default {
    finalize() {
        const inputs = Array.from(document.querySelectorAll('.wpcf7-form-control'));
      
        if (inputs) {
          inputs.forEach(input => {
            input.addEventListener('focus', () => {
              input.labels[0].classList.add('contact__form-label--active');
            })
            input.addEventListener('blur', () => {
              if (!input.value) {
                input.labels[0].classList.remove('contact__form-label--active');
              }
            })
          })
        }
  
        const form = document.querySelector('.wpcf7');
  
        form.addEventListener('wpcf7mailsent', () => {
          inputs.forEach(input => {
            input.labels[0].classList.remove('contact__form-label--active');
          })
        })
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/oNas.js